import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const dateFormats = {
    date: "ll",
    dateTime: "lll",
    dateShort: "MMM Do YY",
    timeShort: "LT",
    longDateTime: "llll",
    shortDateTime: "lll",
    shortDate: "L",
    time: "LTS",
    yearMonthDay: "YYYY-MM-DD",
    yearLongMonthDay: "YYYY-MMM-DD"
};

// Dynamically detect user's local time zone
const defaultTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export default {
    /**
     * Format a date with a specific format key
     * @param {Date|string} date
     * @param {string} dateFormat
     * @param {string} tz - Optional timezone string
     */
    date: (date, dateFormat = "date", tz = defaultTimeZone) =>
        date
            ? dayjs(date)
                  .tz(tz)
                  .format(dateFormats[dateFormat] || dateFormat)
            : "",

    /**
     * Formats full date + time with timezone support
     */
    dateTimeNew: (
        date,
        dateFormat = "D MMM YYYY H:mm:ss",
        tz = defaultTimeZone
    ) => (date ? dayjs(date).tz(tz).format(dateFormat) : ""),

    /**
     * Friendly date display: "Today", "Tomorrow", etc.
     */
    displayDatesWithTime: (givenDate, tz = defaultTimeZone) => {
        if (!givenDate) return "";

        const date = dayjs(givenDate).tz(tz);
        const now = dayjs().tz(tz);
        const today = now.startOf("day");
        const tomorrow = today.add(1, "day");
        const yesterday = today.subtract(1, "day");

        const timeFormat = "H:mm";
        const formattedTime = date.format(timeFormat);

        if (date.isSame(today, "day")) {
            return `Today at ${formattedTime}`;
        } else if (date.isSame(tomorrow, "day")) {
            return `Tomorrow at ${formattedTime}`;
        } else if (date.isSame(yesterday, "day")) {
            return `Yesterday at ${formattedTime}`;
        } else {
            return date.format("D MMM YYYY H:mm:ss");
        }
    }
};
